import { createContext } from 'react';

const PromptbarContext = createContext(null);

export default PromptbarContext;
